import { createContext } from "react";
import { Theme } from "@emotion/react";
import { THEMES, ThemeName } from "./theme";
import { EV_PATHS } from "src/consts/Routes/Ev";
import { useEffect, useMemo, useState } from "react";
import { ROUTES, DEMO_ROUTES } from "src/consts/routes";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useLocation, useSearchParams } from "react-router-dom";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import { SELF_ONBOARDING_PATHS } from "src/consts/Routes/SelfOnboarding";
import { SITE_AUTHENTICATION_PATHS } from "src/consts/Routes/SiteAuthentication";

interface ThemeUsageProps {
  children: React.ReactNode;
}

export const ThemeContext = createContext("");

const ThemeUsage = ({ children }: ThemeUsageProps) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const [themeName, setThemeName] = useState<ThemeName>(
    (sessionStorage.getItem("theme") || "default") as ThemeName,
  );

  const theme: Theme = useMemo(
    () => THEMES[themeName] || THEMES.default,
    [themeName],
  );

  useEffect(() => {
    const isDemoPage = location.pathname.includes(DEMO_ROUTES.DEMO);

    if (location.pathname === ROUTES.INTRODUCTION) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (isDemoPage) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SMART_CHARGING_ROUTES.START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SMART_CHARGING_ROUTES.COMPATIBILITY_SALE)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SMART_CHARGING_ROUTES.ADD_EV_START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(EV_PATHS.START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SITE_AUTHENTICATION_PATHS.START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SELF_ONBOARDING_PATHS.COMPATIBILITY)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }
  }, [location.pathname, pathname, searchParams]);

  return (
    <ThemeProvider theme={theme}>
      <ThemeContext.Provider value={themeName}>
        <CssBaseline />
        {children}
      </ThemeContext.Provider>
    </ThemeProvider>
  );
};

export default ThemeUsage;
